import { render, staticRenderFns } from "./chart_page.vue?vue&type=template&id=b90928e0&scoped=true"
import script from "./chart_page.vue?vue&type=script&lang=js"
export * from "./chart_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90928e0",
  null
  
)

export default component.exports